import { z } from 'zod'
import { EventTypes } from '@mc/track-event'
import { createTracking } from '@mc/tracking-kit'

const pageSource = z.literal('outcome')

const commonSchema = {
  page_source: pageSource,
  outcomeName: z.string().optional(),
}

const outcomesSchema = {
  outcomeRowViewed: {
    eventName: EventTypes.OUTCOME_PAGE_ROW_VIEWED,
    schema: z.object({
      row_name: z.string().optional(),
      location: z.string().optional(),
      ...commonSchema,
    }),
  },
}

const pageSchema = z.object({
  name: z.enum(['Outcome']),
})

export const tracking = createTracking(outcomesSchema, pageSchema)

export const {
  useFireEvent,
  TrackExperimentViewed,
  TrackClick,
  TrackPageViewed,
  TrackingAttributes,
  TrackOnMount,
  TrackVisible,
  TrackEvent,
} = tracking
